import axios from '@/request/http'
import global from '@/constants/Global.constants'

export default {
  storeUpdate (params) {
    return axios.post(global.CMC_BASE + '/store/updateStore', params)
  },
  storeInsert (params) {
    return axios.post(global.CMC_BASE + '/store/insertStore', params)
  },
  storeDelete (params) {
    return axios.post(global.CMC_BASE + '/store/deleteStore', params)
  },
  findAllStoreType () {
    return axios.post(global.CMC_BASE + '/storeType/findAllStoreType')
  },
  modifySalesman (params) {
    return axios.post(global.CMC_BASE + '/store/verifyAllStoreSalesman', params)
  },
  findStoreSalesman (params) {
    return axios.post(global.CMC_BASE + '/store/findStoreSalesman', params)
  }
}



// WEBPACK FOOTER //
// ./src/request/cmc/store.js